import { Button } from "devextreme-react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updsateSelectedDoc } from "../common/Redux/SOPViewer";

export default function FileItem(props) {
  const { docNo, ver, type, docTitle /*, setSelectedDoc, selectedDoc*/ } =
    props;

  const selectedDoc = useSelector((state) => state.SOPViewer.selectedDoc);
  const userInfo = useSelector((state) => state.userInfo);

  const dispatch = useDispatch();

  const onClickDownload = () => {
    doDispatch("download");
  };

  const onClickPdf = () => {
    doDispatch("view");
  };

  const doDispatch = (action) => {
    dispatch(
      updsateSelectedDoc({
        docNo: docNo,
        ver: ver,
        type: type,
        docTitle: docTitle,
        preSelectedDoc: selectedDoc,
        action: action,
      })
    );
  };

  return (
    <React.Fragment>
      {userInfo.jd != "RV" && (
        <Button
          icon={"download"}
          style={{
            marginTop: "0px",
            marginBottom: "0px",
            paddingTop: "0px",
            paddingBottom: "0px",
            visibility: !(type == "1" || type == "4") ? "visible" : "hidden",
          }}
          onClick={onClickDownload}
        />
      )}
      <Button
        icon={"pdffile"}
        style={{
          marginTop: "0px",
          marginBottom: "0px",
          paddingTop: "0px",
          paddingBottom: "0px",
          marginRight: userInfo.jd != "RV" ? "10px" : "35px",
        }}
        onClick={onClickPdf}
      />
    </React.Fragment>
  );
}
